module.exports = __webpack_public_path__ + "img/男2.1ebf3be2.png";